"use strict";

exports.__esModule = true;
var UserTypeIF;

(function (UserTypeIF) {
  UserTypeIF["USER"] = "USER";
  UserTypeIF["END_USER"] = "END_USER";
  UserTypeIF["NONE"] = "NONE";
  UserTypeIF["LEAD"] = "LEAD";
})(UserTypeIF = exports.UserTypeIF || (exports.UserTypeIF = {}));

var AvailabilityIF;

(function (AvailabilityIF) {
  AvailabilityIF["AVAILABLE"] = "AVAILABLE";
  AvailabilityIF["OFFLINE"] = "OFFLINE";
})(AvailabilityIF = exports.AvailabilityIF || (exports.AvailabilityIF = {}));

exports.FEATURE_ACCESS_LEVELS = Object.freeze({
  'READ': 0,
  'WRITE': 1
});
var DriftScopesIF;

(function (DriftScopesIF) {
  DriftScopesIF["org_admin"] = "org_admin";
  DriftScopesIF["member"] = "member";
  DriftScopesIF["agent"] = "agent";
  DriftScopesIF["convoALL"] = "convo-ALL";
  DriftScopesIF["convoONLYMINE"] = "convo-ONLY_MINE";
  DriftScopesIF["convoNOPARTICIPANTS"] = "convo-WITH_NO_PARTICIPANTS";
  DriftScopesIF["video"] = "video";
  DriftScopesIF["video_free"] = "video_free";
  DriftScopesIF["SALES_SEQUENCES"] = "SALES_SEQUENCES";
  DriftScopesIF["calendar_user"] = "calendar_user";
})(DriftScopesIF = exports.DriftScopesIF || (exports.DriftScopesIF = {}));

var DriftRolesIF;

(function (DriftRolesIF) {
  DriftRolesIF["reporting"] = "Reporting";
  DriftRolesIF["playbooks"] = "Playbooks";
  DriftRolesIF["video_admin"] = "Video Admin";
})(DriftRolesIF = exports.DriftRolesIF || (exports.DriftRolesIF = {}));

var DriftAppsIF;

(function (DriftAppsIF) {
  DriftAppsIF["conversationsWeb"] = "conversationsWeb";
  DriftAppsIF["settingsWeb"] = "settingsWeb";
  DriftAppsIF["trafficControl"] = "trafficControl";
  DriftAppsIF["insightsWeb"] = "insightsWeb";
  DriftAppsIF["contactsWeb"] = "contactsWeb";
  DriftAppsIF["marketplaceWeb"] = "marketplaceWeb";
  DriftAppsIF["conversationsDesktop"] = "conversationsDesktop";
  DriftAppsIF["automationWeb"] = "automationWeb";
})(DriftAppsIF = exports.DriftAppsIF || (exports.DriftAppsIF = {}));